import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setIsMobile } from "@/store/app";

import AppHeader from "@/components/AppHeader";
import AppSidebar from "@/components/AppSidebar";
import AppBox from "@/components/AppBox";

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const dispatch = useDispatch();

  const [sidebarOpen, setSidebarOpen] = useState(false)

  const handleToggleSidebarCollapse = () => {
    setSidebarOpen(!sidebarOpen)
  }

  useEffect(() => {
    const handleWindowResize = () => {
      dispatch(setIsMobile(window.innerWidth <= 901));
    };

    handleWindowResize(); // Initialize on mount
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [dispatch]);

  return (
    <AppBox fullWidth className="h-screen">
      {/* Fixed Header */}
      <AppHeader />

      {/* Fixed Sidebar */}
      <AppSidebar onCollapseChange={handleToggleSidebarCollapse} />

      {/* Main Layout */}
      <AppBox fullWidth className="h-screen overflow-y-auto p-4 pt-[76px] md:pl-[76px]">
        {children}
      </AppBox>
    </AppBox>
  );
};

export default AppLayout;